import * as types from './types';

const initialState: string | null = null;

const subdomainReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case types.SET_SUBDOMAIN:
      return action.payload;
    case types.CLEAR_SUBDOMAIN:
      return null;
    default:
      return state;
  }
};

export default subdomainReducer;

